import React from 'react'

const Nodejs_Coding_Pratice_10 = () => {
  return (
    <div>
      <h1>Coding Pratice 10</h1>
    </div>
  )
}

export default Nodejs_Coding_Pratice_10
